/**
 * Auth / current-user endpoints.
 */

import type { UpdateUserDto, User } from '@luminaria/shared';
import { apiClient } from './client';
import { API_ENDPOINTS } from './endpoints';

/** GET /auth/me as it arrives over JSON: dates are ISO strings, plus the server-computed admin flag. */
export type CurrentUser = Omit<User, 'createdAt' | 'updatedAt'> & {
  createdAt: string;
  updatedAt: string;
  /** Server-computed: admin tier or listed in ADMIN_EMAILS. Gates admin-only UI. */
  isAdmin?: boolean;
};

type UpdateCurrentUserInput = UpdateUserDto & { email?: string };

export const authApi = {
  async me(): Promise<CurrentUser> {
    const { data } = await apiClient.get<{ user: CurrentUser }>(API_ENDPOINTS.AUTH.ME);
    return data.user;
  },

  async updateMe(updates: UpdateCurrentUserInput): Promise<CurrentUser> {
    const { data } = await apiClient.put<{ user: CurrentUser }>(API_ENDPOINTS.AUTH.ME, updates);
    return data.user;
  },
};
